<script setup lang="ts">
import UserProfileCard from './UserProfileCard.vue'
</script>

<!--
  个人中心页面骨架：信息卡 + 一张由 app 提供的改密卡片。
  改密表单留在各 app（components/ChangePwdForm.vue），因为它是按服务脚手架生成的，
  portal 的版本还多一个改密成功后跳转的 redirectAfter 开关。

  这个组件刻意不挂任何 meta.perm（路由那一侧）：个人中心是登录用户自己的信息，
  挂权限码会把没配菜单权限的普通用户直接弹到 403。
-->
<template>
  <div class="yc-profile-page">
    <UserProfileCard />
    <el-card>
      <template #header>
        <b>修改密码</b>
      </template>
      <slot />
    </el-card>
  </div>
</template>

<style scoped lang="scss">
.yc-profile-page {
  display: flex;
  flex-direction: column;
  // align-items: stretch（flex 的默认值）必须留着：插槽内容在 app 侧编译，
  // 拿不到本组件的 scoped 属性，靠默认拉伸把改密卡片撑满，
  // 否则每个 app 都得再写一遍 .yc-profile__card 的 width:100%。
  align-items: stretch;
  gap: var(--yc-space-4);
  max-width: 640px;
}
</style>